import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=bc2fe9ea&"
import script from "./BaseListItem.vue?vue&type=script&lang=ts&"
export * from "./BaseListItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
